const statusEnum = {
    inprogress: 'IN PROGRESS',
    stucked: 'Stucked',
    pending: 'PENDING',
    inReview: 'In Review',
    feedback: 'Feedback',
    pipeline: 'Pending',
    active: 'Active',
    deactive: 'Deactivated',
    inActive: 'Inactive',
    complete:'COMPLETED',

};
export { statusEnum };
